import {Component} from 'react'

import DefaultLayout from '../../../Layout/DefaultLayout.jsx'

import './OfferLayout.scss'

export default class OfferLayout extends Component {
  render() {
    return (
      <DefaultLayout className="offer-layout" showStickyPhone={false}>
        <div className="bg-gray-50">
          <div className="container offer-container">
            <div className="row">
              <div className="mx-auto col fl-pages">
                {this.props.children}
              </div>
            </div>
          </div>
        </div>
      </DefaultLayout>
    )
  }
}